/** @deprecated not used */
export class IdClassifier {
    static create() {
        return new IdClassifier();
    }

    private weightedClasses: Record<string, number> = {};

    private overallWeight(): number {
        return Object.values(this.weightedClasses).reduce((acc, value) => acc + value, 0);
    }

    /**
     * Add class to classification.
     * @param label name of class
     * @param weight (integer) how many occurrences of this class exist comparing to other classes */
    public addClass(label: string, weight: number) {
        this.weightedClasses[label] = Math.ceil(weight);
        return this;
    }

    /**
     * Returns stable class based on number(user id in our case).
     * @param id - integer identifier of user.
     */
    public classify(id: number | string): string | undefined {
        const idint = typeof id === 'string' ? parseInt(id, 10) : id;
        /* handle case id is NaN */
        if (idint != idint) {
            return undefined;
        }
        const mod = idint % this.overallWeight();
        let lowerClassBound = 0;
        const keys = Object.keys(this.weightedClasses);
        for (const key of keys) {
            const upperClassBound = lowerClassBound + this.weightedClasses[key];
            if (mod >= lowerClassBound && mod < upperClassBound) {
                return key;
            }
            lowerClassBound = upperClassBound;
        }
        return keys[keys.length - 1];
    }
    public getAvailableClasses(): string[] {
        return Object.keys(this.weightedClasses);
    }
}

/** @deprecated not used */
export const ABCClassifier = IdClassifier.create().addClass('A', 10).addClass('B', 0).addClass('C', 0);
